module.exports = require("./dist/pivot.js");
require("./dist/pivot.css");


//////////////////
// WEBPACK FOOTER
// pivottable (bower component)
// module id = 1225
// module chunks = 1